//Conter entre 8 e 16 caracteres;
//Conter numerais;
//Conter letras minúsculas e maiúsculas;
//Caracteres especiais ?=.*[]#$ ^+=!()+@-%&

const hasNecessaryCharacters = text => {
  return text.length >= 8 && text.length <= 16;
};

const hasNumeral = text => {
  return /\d/.test(text);
};

const hasLowercase = text => {
  return /[a-z]/.test(text);
};

const hasUppercase = text => {
  return /[A-Z]/.test(text);
};

const hasSpecialCharacter = text => {
  // eslint-disable-next-line
  const regexPattern = /[ `!@#$%^&*()_\-=\.?]/;
  return regexPattern.test(text);
};

export function IsValidPassword(password) {
  const errorList = {
    necessaryCharacter: 'NECESSARY_CHARACTERS',
    hasNumeral: 'HAS_NUMERAL',
    hasUpperCase: 'HAS_UPPERCASE',
    hasLowerCase: 'HAS_LOWERCASE',
    hasSpecialCharacter: 'HAS_ESPECIAL_CHAR',
    mensageErros: 'ERROS_FOUND'
  }
  const errorsExpected = {
    [errorList.necessaryCharacter]: true,
    [errorList.hasNumeral]: true,
    [errorList.hasUpperCase]: true,
    [errorList.hasLowerCase]: true,
    [errorList.hasSpecialCharacter]: true,
    [errorList.mensageErros]:[]
  }

  let errorsActual = errorsExpected;
  var mensageErrosActual = errorsActual.ERROS_FOUND
  const setErrorIn = key => {
    mensageErrosActual.push(key)
      errorsActual = {
      ...errorsActual,
      [key]: false,
      'ERROS_FOUND': mensageErrosActual
    }
  };


  if (!hasNecessaryCharacters(password)) {
    setErrorIn(errorList.necessaryCharacter);
  }

  if (!hasNumeral(password)) {
    setErrorIn(errorList.hasNumeral);
  }

  if (!hasUppercase(password)) {
    setErrorIn(errorList.hasUpperCase);
  }

  if (!hasLowercase(password)) {
    setErrorIn(errorList.hasLowerCase);
  }

  if (!hasSpecialCharacter(password)) {
    setErrorIn(errorList.hasSpecialCharacter);
  }

  if (errorsExpected === errorsActual) {
    return true;
  } else {
    return errorsActual;
  }
};
